export default __webpack_public_path__ + "static/media/Armbands of Concealing Shadows.4ed21a23.jpg";